module.exports = __webpack_public_path__ + "img/picture_VIP03.4b9afcb4.png";